import {
  handleFacetOnChange,
  normalizeFacetValues,
} from './products-browser-facet';

const productsBrowserFacetSpecial = () => ({
  get facet() {
    return this.specialFacet;
  },

  get values() {
    // return normalizeFacetValues(this, this.facet, this.facet.values);
  },

  refine(value) {
    this.facet?.refine && this.facet.refine(value);
  }
});

export default productsBrowserFacetSpecial;
